export default __webpack_public_path__ + "static/media/special-jury-prize.e7f00173.svg";